import { apiClient } from '../../../../helpers/api_helper';

export const getAllStateData = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/StateProvince/GetAllStateProvince`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getSelectAllStateData = async () => {
    try {
        const response = await apiClient.get(`/api/v1/StateProvince/GetAllStateProvince`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getStateProvinceDetailsById = async (id: any) => {
    try {
        const response = await apiClient.get(`/api/v1/StateProvince/GetStateProvinceDetailsById?Id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const getStateByCountryId = async (id: any) => {
    try {
        const response = await apiClient.get(`/api/v1/StateProvince/GetStateProvinceSelectListByCountryId?countryId=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const createState = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/StateProvince/InsertStateProvince', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const updateState = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/StateProvince/UpdateStateProvince', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const deleteState = async (id: any) => {
    try {
        const response = await apiClient.delete(`/api/v1/StateProvince/DeleteStateProvince?Id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};